import { combineReducers } from 'redux'
import pdcaBaseState from '../base/redux/pdcaBaseReducer'
import pdcaSetupState from '../setup/redux/setupReducer'
import pdcaPrioritiesState from '../priorities/redux/prioritiesreducer'
import pdcaPlanState from '../plan/redux/planReducer'
import pdcaDoState from '../do/redux/doReducer'
import pdcaCheckState from '../check/redux/checkReducer'
import pdcaActState from '../act/redux/actReducer'
import pdcaHistoryState from '../history/redux/historyReducer'
import pdcaBlacklistState from '../blacklist/redux/blacklistReducer'
import pdcaIntegrationsState from '../integrations/redux/integrationsReducer'
import pdcaPlanDetailsState from '../detalheplano/redux/detalheplanoReducer'
import pdcaRejeitarPlanoState from '../rejeitarplano/redux/rejeitarplanoReducer'
import pdcaAprovarAcaoState from '../aprovaracao/redux/aprovaracaoReducer'
import pdcaAgirActState from '../agiract/redux/agiractReducer'
import pdcaAprovarPlanoPlanState from '../aprovarplanoplan/redux/aprovarplanoplanReducer'
import pdcaStrategicContextState from '../strategiccontext/redux/strategiccontextReducer'


/*
const createPlaceholderReducer = () => {
  const initialState = {
    erro: {},
    load: {}
  }

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
*/


const pdcaReducers = combineReducers({
  pdcaBaseState,
  pdcaSetupState,
  pdcaPrioritiesState,
  pdcaPlanState,
  pdcaDoState,
  pdcaCheckState,
  pdcaActState,
  pdcaHistoryState,
  pdcaBlacklistState,
  pdcaIntegrationsState,
  pdcaPlanDetailsState,
  pdcaRejeitarPlanoState,
  pdcaAprovarAcaoState,
  pdcaAgirActState,
  pdcaAprovarPlanoPlanState,
  pdcaStrategicContextState
})

export default pdcaReducers